module.exports = __webpack_public_path__ + "media/images/android-chrome-512x512-3a2d0222c50a8adae2e2b61f097aa594.png";